import { Component, Host, h, Element } from '@stencil/core';

export interface AhaTags extends HTMLAhaTagsElement {}

/**
 * Renders a list of <aha-tag> components.
 * @slot default - Contents of the default slot.
 */
@Component({
  tag: 'aha-tags',
  styleUrl: 'aha-tags.css',
  shadow: true,
})
export class AhaTags {
  @Element() host!: HTMLAhaTagsElement;
  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }
}
